
import { AnalyticsCore } from './core';
import { EventCategories } from './constants';

/**
 * Events specifically related to authentication
 */
export class AuthEvents extends AnalyticsCore {
  /**
   * Track sign up attempts
   */
  trackSignUp(method: 'email' | 'google' | 'other', success: boolean, error?: string) {
    this.trackEvent({
      category: EventCategories.USER,
      action: 'sign_up_attempt',
      label: method,
      dimensions: {
        auth_method: method,
        success: success,
        error: error || null
      }
    });
    
    // If successful, track the conversion
    if (success) {
      this.trackEvent({
        category: EventCategories.CONVERSION,
        action: 'new_user_registration',
        label: method
      });
    }
  }

  /**
   * Track sign in attempts
   */
  trackSignIn(method: 'email' | 'google' | 'other', success: boolean, error?: string) {
    this.trackEvent({
      category: EventCategories.USER,
      action: 'sign_in_attempt',
      label: method,
      dimensions: {
        auth_method: method,
        success: success,
        error: error || null
      }
    });
    
    // If successful, track the session start
    if (success) {
      this.trackEvent({
        category: EventCategories.USER,
        action: 'session_start',
        label: method
      });
    }
  }

  /**
   * Track sign out
   */
  trackSignOut() {
    this.trackEvent({
      category: EventCategories.USER,
      action: 'sign_out',
      label: 'user initiated'
    });
  }

  /**
   * Track password reset requests
   */
  trackPasswordReset(success: boolean, error?: string) {
    this.trackEvent({
      category: EventCategories.USER,
      action: 'password_reset_request',
      dimensions: {
        success: success,
        error: error || null
      }
    });
  }
}
